import type { AppState } from '@shared-core/store/types'

import { storeKey } from './slice'

export { actionUserLogin, actionUserLogout } from './actions/global'
export {
  type AuthState,
  type AuthUser,
  authSlice,
  login,
  loginTma,
  logout,
  renewAccessToken,
  requestOtp,
  setAccessToken,
  setTokens,
  storeKey,
  whitelist,
} from './slice'

export const selectedIsAuthorized = (state: AppState): boolean => state[storeKey].isAuthorized
export const selectedAuthUser = (state: AppState) => state[storeKey].user
export const selectedAccessToken = (state: AppState) => state[storeKey].accessToken
